export default "__VITE_ASSET__Dk4ytj6v__"